"use strict";

/*
 * Copyright (c) 2025 Xplat-soft s.r.o.
 *
 * This source code is licensed under the terms found in the
 * LICENSE.md file in the root directory of this source tree
 * or at https://universal-sign-in.com/license
 */

import { Color } from "./statics.js";
export const GoogleSigninButton = () => null;
GoogleSigninButton.Color = Color;
GoogleSigninButton.Size = {
  Icon: 0,
  Standard: 1,
  Wide: 2
};
//# sourceMappingURL=GoogleSigninButton.web.js.map